exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SingleDatePicker{width:100%;padding:4px 0}.SingleDatePicker .DayPickerKeyboardShortcuts_buttonReset{display:none}.SingleDatePicker .CalendarDay__selected,.SingleDatePicker .CalendarDay__selected:active,.SingleDatePicker .CalendarDay__selected:hover{background:#7740f9;border:1px solid #7740f9}.SingleDatePicker .SingleDatePickerInput{border-radius:4px;overflow:auto;border:1px solid #B2BEC3;width:100%}.SingleDatePicker .DateInput{overflow:hidden;width:100%}.SingleDatePicker .DateInput_input{padding:11px 15px;border-bottom:none;width:100%;font-size:14px;color:#3f4244}\n", ""]);

// exports
